import { useResetPassword } from 'components/AdminDashboard/components/UsersPage/components/ResetPasswordModal/hooks';

import React from 'react';
import { Box, Button, Grid, Modal, Paper, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface Props {
  onCancel: () => void;
  email: string;
}

const ResetPasswordModal: React.FC<Props> = ({ onCancel, email }) => {
  const { resetPassword, isLoading, error } = useResetPassword(onCancel);

  return (
    <Modal open>
      <Paper
        sx={{
          borderRadius: '20px',
          elevation: 9,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          padding: 3,
          width: { xs: '100%', md: '600px' },
        }}
        data-testid="modal-reset-password"
      >
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="textXLBold">
                Change User’s password
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Are you sure you want to reset the password?
              </Typography>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Typography color="error" variant="subtitle2" sx={{ whiteSpace: 'break-spaces' }}>
                  {error}
                </Typography>
              </Grid>
            )}
            <Grid container spacing={2} item xs={12}>
              <Grid item>
                <LoadingButton variant="contained" onClick={() => resetPassword(email)} loading={isLoading}>
                  Yes
                </LoadingButton>
              </Grid>
              <Grid item>
                <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Modal>
  );
};

export default ResetPasswordModal;
